// extracted by mini-css-extract-plugin
export var anchorLink = "ResponsiveBanner-module--anchorLink--4a43e";
export var background = "ResponsiveBanner-module--background--aab2a";
export var banner = "ResponsiveBanner-module--banner--42815";
export var bottomMargin = "ResponsiveBanner-module--bottomMargin--2bbe9";
export var buttonContainer = "ResponsiveBanner-module--buttonContainer--4ddf1";
export var buttonWrapper = "ResponsiveBanner-module--buttonWrapper--60a70";
export var centerAlign = "ResponsiveBanner-module--centerAlign--f54aa";
export var leftAlign = "ResponsiveBanner-module--leftAlign--cd832";
export var rightAlign = "ResponsiveBanner-module--rightAlign--f15a8";
export var showButton = "ResponsiveBanner-module--showButton--550e8";
export var topMargin = "ResponsiveBanner-module--topMargin--b6c19";